export default __webpack_public_path__ + "static/media/icon-hood.067c1d87.svg";